<mat-card class="viewerholder">
  <div class="docheader">    
    <div class="name">
      {{formName}}

      


     </div>


    <div class="right_pannel">
     

        <button mat-icon-button  color="primary" (click)="ClosePDFReportData(CloseViewDocument)">
          <mat-icon>close</mat-icon>
        </button>

    </div>
  </div>

  
  <div class="docdetail">     
  

    <div class="viewList">

     

      <!-- search bar -->
      <div class="search">

        <mat-slide-toggle color="primary" [checked]="showCustomField" (change)="changeToggleCustom($event)"> 
          {{title}}   
        </mat-slide-toggle>
        
        <div class="search_input">
          <input type="text" class="search"  placeholder="Enter search email here"  [(ngModel)]="searchKeyword" (keyup.enter)="searchFormData()">              
        <button mat-icon-button *ngIf="searchKeyword"  (click)="clearSearchData()" class="clearSearch" color="basic" ><mat-icon>close</mat-icon></button>
        </div>

        <div class="datepicker" *ngIf="showDisplayColumn!=true">
          <input type="text" ngxDaterangepickerMd 
          placeholder="Select date range"
          [(ngModel)]="dateRange"
          (change)="selectedDateRange($event)"
          class="form-control"/>
          <button mat-icon-button color="basic" (click)="clearDateRange()" *ngIf="dateRange" ><mat-icon>close</mat-icon></button>
        </div>

        <button *ngIf="showDisplayColumn!=true" class="statusDropdown" mat-stroked-button color="primary"
        [matMenuTriggerFor]="priority">{{preoritytext}}<mat-icon>arrow_drop_down</mat-icon></button>
      <mat-icon class="cancelFilter" (click)="clearPreoority()" *ngIf="preoritytext!='Status'">close</mat-icon>
      <mat-menu #priority="matMenu">
        <button mat-menu-item (click)="onFilterByPreority(1,'Sent')">Sent</button>
        <button mat-menu-item (click)="onFilterByPreority(2,'InProgress')">InProgress</button>
        <button mat-menu-item (click)="onFilterByPreority(3,'Completed')">Completed</button>
      </mat-menu>

        <button (click)="searchFormData()" class="go">Go</button>
        
        <!-- <button (click)="mapPlaceHolder()" class="go">Map</button> -->

        
        <button *ngIf="showDisplayColumn==true" class="viewBtn" mat-icon-button (click)="applyFilter(customize)" matTooltipClass="tooltip"
         matTooltip="Customize Column">
        <mat-icon>view_column</mat-icon>
      </button>

        <!-- <button  class="filterList" mat-icon-button (click)="applyFilter(customize)"
          matTooltipClass="tooltip" matTooltip="Filters">
          <mat-icon>filter_list</mat-icon>
         </button> -->

       

       <div *ngIf="showCustomField==true" class="document" > 
        <mat-form-field>
          <mat-select [(ngModel)]="documentSelected"
           placeholder="Select Document" (selectionChange)="GetDocumentJson($event.value)">
              <mat-option *ngFor="let doc of projectDocuments" [value]="doc.projectDocumentID">
                  {{ doc.documentName }}
              </mat-option>
          </mat-select>
       </mat-form-field>

       

       </div>
      <button class="download" *ngIf="showCustomField==true" (click)="downloadData()">Download</button>
      </div>     

    </div>

    <div class="tableWrapper" *ngIf="showCustomField==false">
      <table class="table"  *ngIf="!noRecordFound">
      
        <tr>
          <th>From</th>
          <th>Project Name</th>
          <th>Date</th>
          <th>Name</th>
          <th>Participant Emails</th>
          <th>Status</th>
          <th>Docs link</th>
          <th>Docs</th>
          <th>Type</th>
          <th>Action</th>
        </tr>
     
        <tr *ngFor="let project of projects">
         
            <td>             
              <p *ngIf="project.pType==0"><mat-icon matTooltip="Sign Now">border_color</mat-icon></p>
              <p *ngIf="project.pType==1"><mat-icon matTooltip="Fill">description</mat-icon></p> 
            </td>          

          <td>{{ project.projectName }}</td>
          <td>{{ project.createdOn }}</td>
          <td>{{project.name}}</td>
          <td *ngIf="project.participants">{{ project.participants }}</td>
          <td *ngIf="!project.participants">--</td>
          <td>{{ project.projectStatus }}</td>
          <td>
            <ng-container *ngFor="let link of project.linksToCompletedDocuent;let i=index" >
              <a class="multiLink" [href]="link" target="_blank">
                {{i+1}}              
              </a>
            </ng-container>
            
            <span *ngIf="project.linksToCompletedDocuent==null || project.linksToCompletedDocuent.length==0">--</span>
          </td>
          <td>
            <button  color="primary" mat-icon-button *ngIf="project.linksToCompletedDocuent && project.linksToCompletedDocuent.length" (click)="downloadAsZip(project)">
              
              <mat-icon>folder_zip</mat-icon>
            </button>
         
            <!-- <span *ngIf="project.linksToCompletedDocuent==null || project.linksToCompletedDocuent.length==0">--</span> -->
            <button mat-icon-button color="primary" *ngIf="project.pType==0" matTooltip="Send Mail" (click)="resendEmailtoParticipants(project)">
              <mat-icon>send</mat-icon>
            </button>
          </td>

          <td>
            <p *ngIf="project.coreID>0"><mat-icon matTooltip="Core">app_registration</mat-icon></p>
            <p *ngIf="project.contactID>0"><mat-icon matTooltip="Contact">contact_mail</mat-icon></p>
          </td>

          <td>
            <button *ngIf="project.projectStatus !== 'Completed'" color="primary" mat-icon-button (click)="SendRemainder(project)">
            <mat-icon>notifications_active</mat-icon>
          </button>
          <!-- <span *ngIf="project.projectStatus == 'Completed'">--</span> -->
           <button *ngIf="project.projectStatus == 'Completed'" color="primary" mat-icon-button matTooltip="Sync Documents"
           (click)="mapPlaceHolder(project)">
           <mat-icon>sync</mat-icon>
           </button>
        </td>
        </tr>
      
    </table>
    
    <div *ngIf="noRecordFound" class="noRecordFound">No Record Found</div>
    </div> 
   
   <div style="height: 78vh;overflow-x:auto;overflow-y:auto;"   *ngIf="showCustomField==true"> 

    <table class="table" *ngIf="rowDataList.length>0">
      <!-- Header Row -->
      <thead>
        <tr>
          <th class="mat-header-cell date" *ngFor="let clm of showCustomColumninList">
            <span>{{ clm.fieldName }}</span>
          </th>
        </tr>
      </thead>
    
      <!-- Body Rows -->
      <tbody>
        <tr *ngFor="let rowData of rowDataList">
          <td class="mat-cell date " *ngFor="let clm of showCustomColumninList">

            <ng-container *ngIf="clm.fieldName== 'From'">
              <div class="from">
                <!-- <p *ngIf="rowData.coreID>0"><mat-icon matTooltip="Core">app_registration</mat-icon></p>
                <p *ngIf="rowData.contactID>0"><mat-icon matTooltip="Contact">contact_mail</mat-icon></p> -->
                <p *ngIf="rowData.pType==0"><mat-icon matTooltip="Sign Now">border_color</mat-icon></p>
                <p *ngIf="rowData.pType==1"><mat-icon matTooltip="Fill">description</mat-icon></p> 
              </div>
            </ng-container>

            <ng-container *ngIf="clm.fieldName!== 'Docs link' && 
            clm.fieldName!== 'Docs' &&  clm.fieldName!== 'Action' && clm.fieldName!== 'From'
            && clm.fieldName !== 'Type'">
              <p>
                {{ getFieldColumnValues(rowData, clm) }}
              </p>
            </ng-container>
             <!-- Docs link -->
      <ng-container *ngIf="clm.fieldName === 'Docs link'">
      <a class="multiLink"  *ngFor="let link of rowData.finalDocuments; let i = index" [href]="link" target="_blank">
        {{ i + 1 }}
      </a>
      <span *ngIf="!rowData.finalDocuments || rowData.finalDocuments.length === 0">--</span>

      
    </ng-container>

    <!-- Docs -->
    <ng-container *ngIf="clm.fieldName === 'Docs'">
      <button mat-icon-button color="primary" *ngIf="rowData.finalDocuments && rowData.finalDocuments.length" (click)="downloadAsZipProject(rowData)">
        <mat-icon>folder_zip</mat-icon>
      </button>
      <!-- <span *ngIf="!rowData.finalDocuments || rowData.finalDocuments.length === 0">--</span> -->
      <button mat-icon-button color="primary" *ngIf="rowData.pType==0"  matTooltip="Send Mail" (click)="resendEmailtoParticipants(rowData)">
        <mat-icon>send</mat-icon>
      </button>  
    </ng-container>

    <ng-container *ngIf="clm.fieldName === 'Type'">
      <p *ngIf="rowData.coreID>0"><mat-icon matTooltip="Core">app_registration</mat-icon></p>
      <p *ngIf="rowData.contactID>0"><mat-icon matTooltip="Contact">contact_mail</mat-icon></p>
    </ng-container>

    <ng-container *ngIf="clm.fieldName === 'Action'">
      <button color="primary" mat-icon-button *ngIf="rowData.projectStatus !== 'Completed'"  (click)="SendRemainder(rowData)">
        <mat-icon>notifications_active</mat-icon>
      </button>
      <!-- <span *ngIf="rowData.projectStatus == 'Completed'">--</span> -->
      <button *ngIf="rowData.projectStatus == 'Completed'" color="primary" mat-icon-button matTooltip="Sync Documents"
      (click)="mapPlaceHolderCustom(rowData)">
      <mat-icon>sync</mat-icon>
       </button>
    </ng-container>

          </td>
        </tr>
      </tbody>

      
    </table>
    
   
    <div *ngIf="rowDataList.length==0" class="noRecordFound">No Record Found</div>
  </div>

  </div>
</mat-card>

<div class="overlay" (click)="ClosePDFReportData(CloseViewDocument)"></div>


<ng-template #customize>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
    Select the columns you want to display in this list
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <mat-dialog-content class="mat-typography">

    <div class="allheaders">
      <div class="fixrow sep">
        <span>Column Headers</span>
        <span> Active Columns</span>
      </div>

      <ng-container *ngFor="let item of displayColumn;let i = index">        
        <div class="sep">
          <span>{{item.fieldName}}</span>          
          <span>
            <mat-slide-toggle color="primary" [checked]="item.isDisplay" (change)="changedToggle(item,$event)">
            </mat-slide-toggle>           
          </span>
        </div>
      </ng-container>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!SubmitColumnsButton" (click)="onSubmitColumns()">Save</button>
  </mat-dialog-actions>
</ng-template>


 <!-- <table class="table1" style="overflow-y: scroll;max-height:600px;" *ngIf="datatable.length>0">
      <span *ngFor="let row of datatable; let i = index">
          <thead>
             <th class="col">{{row.columnName}}
             </th>
          </thead>

           <tr *ngFor="let rowdata of row.value;">
               
            <td>
              <ng-container *ngIf="row.type=='Signature'; else elseifInitials">
                <img *ngIf="rowdata.substring(0,5) == 'data:'" height="32px" src={{rowdata}}/>
                 <p *ngIf="rowdata=='-'">-</p>
                 <p *ngIf="rowdata.substring(0,5)!= 'data:' && rowdata!='-'">{{rowdata}}</p>          
              </ng-container>
  
              <ng-template #elseifInitials>
              <ng-container *ngIf="row.type=='Initials'; else elseifImage">
                <img *ngIf="rowdata.substring(0,5) == 'data:'" height="32px"   src={{rowdata}}/>
                 <p *ngIf="rowdata=='-'">-</p>
                 <p *ngIf="rowdata.substring(0,5)!= 'data:' && rowdata!='-'">{{rowdata}}</p>
              </ng-container>
              </ng-template>
             
  
              <ng-template #elseifImage>
                <ng-container *ngIf="row.type=='Image'; else elseifFile">
                  <img *ngIf="rowdata.substring(0,5) == 'data:'" height="32px"   src={{rowdata}}/>
                  <p *ngIf="rowdata=='-'">-</p>
                </ng-container>
              </ng-template>
  
              
                <ng-template #elseifFile>
                  <ng-container *ngIf="row.type=='File'; else elseRow">
                    <p *ngIf="rowdata.substring(0,5) == 'data:'" (click)="DownloadFile(rowdata,row)"> Download</p>
                    <p *ngIf="rowdata=='-'">-</p>
                  </ng-container>
                  </ng-template>
                    
                  
              <ng-template #elseRow><p>{{rowdata}}</p></ng-template>   
            </td> 
              
          </tr> 
    
        </span>
    </table> -->
